import ApiService from "@/core/services/api.service";
// action types
export const PAGINATION_POINTS_COULD_DATA = "paginationPointsCouldData";
export const LIST_POINTS_COULD_DATA = "listPointsCouldData";
export const GET_POINTS_COULD_DATA = "getPointsCouldData";
export const GET_POINTS_COULD_FORM_DATA = "getPointsCouldFormData";
export const POST_POINTS_COULD_DATA = "postPointsCouldData";
export const PUT_POINTS_COULD_DATA = "putPointsCouldData";
export const PUT_POINTS_COULD_STATUS_DATA = "putPointsCouldStatusData";
export const DELETE_POINTS_COULD_DATA = "deletePointsCouldData";
// mutation types
export const SET_PAGINATION = "setPagination";
export const SET_IS_CLEAR_PAGINATION = "setIsClearPagination";
export const CLEAR_PAGINATION = "clearPagination";
export const SET_STATE_PRAM_POINTS_COULD = "setStarePramPointsCould";


export default {
  state: {
    path: "points_could",   
    isClearPagination: true,
    pagination: {
      page: 1,
      perPage: 25,
      orderBy: "id",
      isDesc: true,
      sortDirection: "asc",
      filter: "",
      data_pram:''
    }
  },
  getters: {},
  actions: {
    [PAGINATION_POINTS_COULD_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/pagination`, {
        params: payload.params
      });
    },
    [LIST_POINTS_COULD_DATA](context) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}`);
    },
    [GET_POINTS_COULD_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/${payload.id}`);
    },
    [GET_POINTS_COULD_FORM_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/points_could_form/${payload.id}`);
    },
    [POST_POINTS_COULD_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.post(`${context.state.path}`, payload.data);
    },
    [PUT_POINTS_COULD_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/${payload.id}`,
        payload.data
      );
    },
    [PUT_POINTS_COULD_STATUS_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/status/${payload.id}`,
        payload.data
      );
    },
    [DELETE_POINTS_COULD_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.delete(`${context.state.path}/${payload.id}`);
    }
  },
  mutations: {
    [SET_STATE_PRAM_POINTS_COULD](state, payload) {
      state.data_pram = payload;
    },
    [SET_PAGINATION](state, payload) {
      state.pagination = payload.pagination;
    },
    [SET_IS_CLEAR_PAGINATION](state, payload) {
      state.isClearPagination = payload.isClearPagination;
    },
    [CLEAR_PAGINATION](state) {
      state.pagination = {
        page: 1,
        perPage: 25,
        orderBy: "id",
        isDesc: true,
        sortDirection: "asc",
        filter: ""
      };
    }
  }
};
